<template>
  <block-item-card
    :min-height="minBlockHeight"
    :title="$t('ALM.Section.LoansPortfolio.NetInterestIncome.Title')"
  >
    <div
      class="py-5 px-4 d-flex justify-start flex-column"
      style="height: 315px; width: 100%; gap:20px;"
    >
      <div
        class="d-flex flex-column"
        style="width: 100%; gap: 10px;"
      >
        <div
          class="d-flex justify-space-between align-center"
          style="width: 100%;"
        >
          <p class="pa-0 ma-0">
            {{ $t('ALM.Section.LoansPortfolio.NetInterestIncome.Periods.ThreeMonths') }}
          </p>
          <p class="pa-0 ma-0 text-size-28 font-weight-medium">
            {{ formatNumberShort(threeMonths) }}
          </p>
        </div>
        <v-progress-linear
          :value="threeMonthsPercentage"
          color="synthesis-ui-green-02"
          height="10"
          rounded
          background-color="synthesis-ui-grey-06"
        />
      </div>
      <div
        class="d-flex flex-column"
        style="width: 100%; gap: 10px;"
      >
        <div
          class="d-flex justify-space-between align-center"
          style="width: 100%;"
        >
          <p class="pa-0 ma-0">
            {{ $t('ALM.Section.LoansPortfolio.NetInterestIncome.Periods.OneYear') }}
          </p>
          <p class="pa-0 ma-0 text-size-28 font-weight-medium">
            {{ formatNumberShort(oneYear) }}
          </p>
        </div>
        <v-progress-linear
          :value="oneYearPercentage"
          color="synthesis-ui-green-02"
          height="10"
          rounded
          background-color="synthesis-ui-grey-06"
        />
      </div>
    </div>
  </block-item-card>
</template>

<script>
import BlockItemCard from '@/theme/default/components/common/BlockItemCard'
import chartsColorMixin from '@/theme/default/components/charts/mixins/chartsColorMixin'
import { toNumberFormatNotationShort } from '@/lib/utils/helper'

export default {
  name      : 'NetInterestIncome',
  components: {
    BlockItemCard
  },
  mixins   : [chartsColorMixin],
  props    : {},
  dataStore: {
    Loans: 'ALM.Loans.Data'
  },
  data () {
    return {
      minBlockHeight: 350,
      chartHeight   : 120
    }
  },
  computed: {
    interestIncome () {
      return this.Loans.InterestIncome || {}
    },
    threeMonths () {
      return this.interestIncome.interestIncome3m || 0
    },
    oneYear () {
      return this.interestIncome.interestIncome12m || 0
    },
    threeMonthsPercentage () {
      if (this.oneYear === 0) return 0
      return Math.min((this.threeMonths / this.oneYear) * 100, 100)
    },
    oneYearPercentage () {
      return 100
    },
    currencySymbol () {
      return this.Loans?.BaseCurrency?.displaySymbol || ''
    }
  },

  mounted () {},

  methods: {
    formatNumberShort (value) {
      return this.currencySymbol + toNumberFormatNotationShort(value)
    }

  }
}
</script>

<style scoped>
.border-top {
  border-top: 1px solid #e0e0e0;
}

.text-medium-emphasis {
  color: rgba(0, 0, 0, 0.6) !important;
}

.synthesis-brand-dark-blue--text {
  color: #041F30 !important;
}

.chart {
  width: 100%;
}
</style>
